module.exports = __webpack_public_path__ + "img/orange_044.a50d3cfc.png";